export const currencyFormatter = ({ locale = 'en-US', currency = 'USD' }: { locale?: string; currency?: string }) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    trailingZeroDisplay: 'stripIfInteger',
  } as Intl.NumberFormatOptions);
